import JSEncrypt from "jsencrypt";

// 私钥解密
export default function decrypt(text) {
    const decrypt = new JSEncrypt();
    decrypt.setPrivateKey(PRIV_KEY);
    return decrypt.decrypt(text);
}


const PRIV_KEY = `
-----BEGIN PRIVATE KEY-----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-----END PRIVATE KEY-----
`;

